<template>
  <div class="UsernameRow">
    <div class="ColorBox" v-bind:style="colorBoxStyle"></div>
    <div>{{ username }}</div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class UsernameRow extends Vue {
  @Prop(String) readonly username!: string;
  @Prop(String) readonly color!: string;

  get colorBoxStyle(): string {
    return `background-color: ${this.color}`;
  }
}
</script>

<style scoped lang="scss">
.UsernameRow {
  margin: 5px;

  position: relative;
  display: flex;
  flex-direction: row;

  & > * {
    margin-right: 5px;
  }
}

.ColorBox {
  width: 1em;
  height: 1em;
  border: 1px solid black;

  &:hover {
    border: 1px solid white;
  }
}
</style>
